import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../client";

/**
 * Hook for generating a setlist
 */
export function useGenerateSetlist() {
  return useMutation({
    mutationFn: async (params = {}) => {
      const body = {};

      if (params.era) {
        body.era = params.era;
      }

      if (params.jamminess !== undefined) {
        body.jamminess = params.jamminess;
      }

      if (params.same_show_segues) {
        body.same_show_segues = true;
      }

      console.info("[Generate] POST", apiClient.baseURL + "/generate", body);
      return apiClient.post("/generate", body);
    },
    onError: (error) => {
      console.error("Failed to generate setlist:", error);
    },
  });
}
